import { Channel } from '@at/consumer-web-types';
export var isHomePage = function () {
    var _a;
    return ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.toString()) === '/';
};
export var dubifyUrl = function (url, channel, env) {
    var prefix = env === 'preprod' || env === 'local' ? "-".concat(env) : '';
    return ((!!channel && [Channel.trucks, Channel.plant, Channel.farm].includes(channel)
        ? "//www".concat(prefix, ".autotrader.co.uk")
        : '') + url);
};
export var appendTPFEnvironmentPrefix = function (env, url) {
    return url.replace(/sell-commercial\.autotrader\.co\.uk/, "sell-commercial-".concat(env, ".autotrader.co.uk"));
};
